export const FEATURE_FLAGS = {
    INSTALLER_INVITATION_ENABLED: 'installer-invitation-enabled',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
